import { useLocation, useNavigate } from "react-router-dom";
import FlashFocus from "../../../components/FlashFocus";

export default function ReviewDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const transliteration = state?.transliteration ?? state?.transcription ?? state?.pronunciation;
  const backText = state?.backText ?? "No definition available";
  const backgroundUrl = state?.backgroundUrl ?? state?.imageUrl;
  const usageExample = state?.usageExample ?? null;
  const returnPath = state?.returnPath;
  const returnState = state?.returnState;

  const handleComplete = () => {
    if (returnPath) {
      navigate(returnPath, { state: returnState, replace: true });
      return;
    }
    navigate(-1);
  };

  return (
    <FlashFocus
      usageExample={usageExample}
      word={state?.word}
      transliteration={transliteration}
      audioUrl={state?.voiceUrl}
      duration={7000}
      backText={backText}
      backgroundUrl={backgroundUrl}
      repeatInterval={900}
      speechGapMs={120}
      onComplete={handleComplete}
    />
  );
}
